/* Innolight: progressive navigation only. Product/cart, app and video behaviour stay native. */
(() => {
  'use strict';
  if (window.innolightPolishLoaded) return;
  window.innolightPolishLoaded = true;
  const mobile = window.matchMedia('(max-width: 749px)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mounted = new Map();
  let serial = 0;
  const words = document.documentElement.lang.startsWith('da')
    ? { previous: 'Vis forrige', next: 'Vis næste', of: 'af', items: 'Visning' }
    : { previous: 'Previous items', next: 'Next items', of: 'of', items: 'Showing' };
  function mount(rail, mobileOnly) {
    if (mounted.has(rail) || rail.children.length < 2) return;
    const cards = Array.from(rail.children);
    const abort = new AbortController();
    const signal = abort.signal;
    const oldTab = rail.getAttribute('tabindex');
    const oldId = rail.id;
    if (!rail.id) rail.id = 'innolight-rail-' + (++serial);
    const controls = document.createElement('div');
    controls.className = 'innolight-rail-controls';
    controls.hidden = true;
    const count = document.createElement('span');
    count.className = 'innolight-rail-controls__count';
    count.setAttribute('aria-live', 'polite');
    count.setAttribute('aria-atomic', 'true');
    const buttons = document.createElement('div');
    buttons.className = 'innolight-rail-controls__buttons';
    function createButton(label, path) {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', label);
      button.setAttribute('aria-controls', rail.id);
      button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + path + '"/></svg>';
      return button;
    }
    const prev = createButton(words.previous, 'M19 12H5m6-6-6 6 6 6');
    const next = createButton(words.next, 'M5 12h14m-6-6 6 6-6 6');
    buttons.append(prev, next);
    controls.append(count, buttons);
    rail.after(controls);
    let frame = 0;
    let first = 0;
    function starts() {
      const rect = rail.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
      return cards.map(card => card.getBoundingClientRect().left - rect.left - rail.clientLeft - padding + rail.scrollLeft);
    }
    function measure() {
      frame = 0;
      const overflow = rail.scrollWidth > rail.clientWidth + 4;
      const enabled = overflow && (!mobileOnly || mobile.matches);
      controls.hidden = !enabled;
      if (!enabled) {
        if (oldTab === null) rail.removeAttribute('tabindex');
        else rail.setAttribute('tabindex', oldTab);
        return;
      }
      rail.tabIndex = 0;
      const rect = rail.getBoundingClientRect();
      const visible = cards.map((card, index) => ({ index, rect: card.getBoundingClientRect() }))
        .filter(item => item.rect.left >= rect.left - 5 && item.rect.right <= rect.right + 5);
      const positions = starts();
      first = positions.reduce((best, value, index) => Math.abs(value - rail.scrollLeft) < Math.abs(positions[best] - rail.scrollLeft) ? index : best, 0);
      const start = visible.length ? visible[0].index : first;
      const end = visible.length ? visible[visible.length - 1].index : first;
      const range = start === end ? String(start + 1) : (start + 1) + '–' + (end + 1);
      const text = range + ' ' + words.of + ' ' + cards.length;
      if (count.textContent !== text) count.textContent = text;
      prev.setAttribute('aria-disabled', rail.scrollLeft <= 4 ? 'true' : 'false');
      next.setAttribute('aria-disabled', rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 4 ? 'true' : 'false');
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(measure); }
    function go(index, instantly) {
      if (controls.hidden) return;
      const positions = starts();
      const i = Math.max(0, Math.min(cards.length - 1, index));
      rail.scrollTo({ left: positions[i], behavior: instantly || reduced.matches ? 'instant' : 'smooth' });
    }
    prev.addEventListener('click', () => { if (prev.getAttribute('aria-disabled') !== 'true') go(first - 1, false); }, { signal });
    next.addEventListener('click', () => { if (next.getAttribute('aria-disabled') !== 'true') go(first + 1, false); }, { signal });
    rail.addEventListener('scroll', schedule, { passive: true, signal });
    rail.addEventListener('keydown', event => {
      if (event.target !== rail || controls.hidden) return;
      const index = { ArrowLeft: first - 1, ArrowRight: first + 1, Home: 0, End: cards.length - 1 }[event.key];
      if (index !== undefined) { event.preventDefault(); go(index, false); }
    }, { signal });
    rail.addEventListener('shopify:block:select', event => {
      const i = cards.findIndex(card => card === event.target || card.contains(event.target));
      if (i >= 0) go(i, true);
    }, { signal });
    const resize = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;
    if (resize) resize.observe(rail);
    window.addEventListener('resize', schedule, { passive: true, signal });
    mobile.addEventListener('change', schedule);
    mounted.set(rail, () => {
      abort.abort(); cancelAnimationFrame(frame); if (resize) resize.disconnect();
      mobile.removeEventListener('change', schedule); controls.remove();
      if (oldTab === null) rail.removeAttribute('tabindex'); else rail.setAttribute('tabindex', oldTab);
      if (!oldId) rail.removeAttribute('id');
      mounted.delete(rail);
    });
    measure();
  }
  function init(root) {
    root.querySelectorAll('.geckio-collist--layout-gitter .geckio-collist__grid').forEach(rail => mount(rail, true));
    root.querySelectorAll('.innolight-reviews__rail').forEach(rail => mount(rail, false));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    mounted.forEach((destroy, rail) => { if (event.target === rail || event.target.contains(rail)) destroy(); });
  });
})();
